import { useMutation } from "@tanstack/react-query";
import { accountGroupContract } from "@common/contracts/account-group.contract";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { invalidateAccountRelatedQueries } from "./account.api";

const accountGroupClient = getBackendAPIClient(accountGroupContract);

interface DeleteAccountGroupsBulkMutationVariables {
    groupId: string;
    entityId: number;
}

export function useDeleteAccountGroupsBulkMutation() {
    const { workspaceId } = useScope();

    return useMutation({
        mutationFn: async (
            groups: DeleteAccountGroupsBulkMutationVariables[],
        ) => {
            const response = await accountGroupClient.entityDeleteBulk({
                body: groups.map(({ groupId, entityId }) => ({
                    groupId,
                    entityId,
                })),
            });

            return response.body;
        },
        onSettled: (_data, _error, groups) =>
            invalidateAccountRelatedQueries({
                entityIds: Array.from(
                    new Set(groups.map((group) => group.entityId)),
                ),
                workspaceId,
            }),
    });
}
